import { styled } from '@mui/material/styles';
import MuiDrawer from '@mui/material/Drawer';
import * as React from 'react';
import { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import AssignmentIcon from '@mui/icons-material/Assignment';
import ButtonBase from '@mui/material/ButtonBase';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import ApiIcon from '@mui/icons-material/Api';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import emailjs from "emailjs-com";
import { initializeApp } from 'firebase/app';
import { getFirestore, addDoc, collection, onSnapshot, query, where } from 'firebase/firestore'

/* Identify the current user */
const user_email = window.localStorage.getItem('user_email');

// Connect to current firebase project
const firebaseApp = initializeApp({
    apiKey: "AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY",
    authDomain: "ambient-systems.firebaseapp.com",
    databaseURL: "https://ambient-systems-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "ambient-systems",
    storageBucket: "ambient-systems.appspot.com",
    messagingSenderId: "1001740093061",
    appId: "1:1001740093061:web:b516ca06c0e80199b90bec"
  });
const firestore = getFirestore(firebaseApp);

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
      '& .MuiDrawer-paper': {
        position: 'relative',
        whiteSpace: 'nowrap',
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
        boxSizing: 'border-box',
        ...(!open && {
          overflowX: 'hidden',
          transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
          width: theme.spacing(7),
          [theme.breakpoints.up('sm')]: {
            width: theme.spacing(9),
          },
        }),
      },
    }),
  );

const drawerWidth = 220;

export default function DataAugmentationPage() {
    const [open, setOpen] = React.useState(false);
    const toggleDrawer = () => {
        setOpen(!open);
    };

    const [show1, setShow1] = useState(false);

    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const [open4, setOpen4] = useState(false);
    const [open5, setOpen5] = useState(false);
    const [open6, setOpen6] = useState(false);
    const [open7, setOpen7] = useState(false);
    const [open8, setOpen8] = useState(false);
    const [open9, setOpen9] = useState(false);
    const [open10, setOpen10] = useState(false);
    const [open11, setOpen11] = useState(false);
    const [open12, setOpen12] = useState(false);
    const [open13, setOpen13] = useState(false);

    const [flag1, setFlag1] = useState(false);
    const [flag2, setFlag2] = useState(false);
    const [flag3, setFlag3] = useState(false);
    const [flag4, setFlag4] = useState(false);
    const [flag5, setFlag5] = useState(false);
    const [flag6, setFlag6] = useState(false);
    const [flag7, setFlag7] = useState(false);
    const [flag8, setFlag8] = useState(false);
    const [flag9, setFlag9] = useState(false);
    const [flag10, setFlag10] = useState(false);
    const [flag11, setFlag11] = useState(false);
    const [flag12, setFlag12] = useState(false);
    const [flag13, setFlag13] = useState(false);

    const handleClose1 = () => {
        setOpen1(false)
    }

    const handleClose2 = () => {
        setOpen2(false)
    }

    const handleClose3 = () => {
        setOpen3(false)
    }

    const handleClose4 = () => {
        setOpen4(false)
    }

    const handleClose5 = () => {
        setOpen5(false)
    }

    const handleClose6 = () => {
        setOpen6(false)
    }

    const handleClose7 = () => {
        setOpen7(false)
    }

    const handleClose8 = () => {
        setOpen8(false)
    }

    const handleClose9 = () => {
        setOpen9(false)
    }

    const handleSubmit1 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API1")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag1(true)
            }
        })

        if (flag1) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API1"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose1()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
        // if (auth == "" || body == "") {
        //     alert("Please submit all required information")
        // } else {
        //     const obj = JSON.parse(body)
        //     axios
        //         .post(
        //             "https://estimategateway-cs6y6qo5.uc.gateway.dev/estimate",
        //             obj,
        //             {
        //                 headers: {
        //                     Authorization: 'Bearer ' + auth,
        //                     "x-api-key": 'AIzaSyBamRPS6NxxPg7lplFrxZd36fLWg9ZUTDY',
        //                 },
        //             }
        //         )
        //         .then((response) => {
        //             console.log(response.data)
        //             const res = response.data
        //             var obj = res
        //             Object.values(res).map(element => {
        //                 if (typeof element == 'object') {
        //                     obj = Object.assign(obj, element)
        //                 }
        //             });
        //             exportJSONToCSV([obj])
        //             alert("Successful! Please check the data file downloaded.")
        //             handleClose1()
        //         }).catch((error) => {
        //             console.log(error.message)
        //             alert(error.message)
        //         });
        // }
    }

    const handleSubmit2 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API2")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag2(true)
            }
        })

        if (flag2) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API2"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose2()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit3 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API3")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag3(true)
            }
        })

        if (flag3) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API3"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose3()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit4 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API4")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag4(true)
            }
        })

        if (flag4) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API4"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose4()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit5 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API5")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag5(true)
            }
        })

        if (flag5) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API5"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose5()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit6 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API6")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag6(true)
            }
        })

        if (flag6) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API6"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose6()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit7 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API7")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag7(true)
            }
        })

        if (flag7) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API7"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose7()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit8 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API8")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag8(true)
            }
        })

        if (flag8) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API8"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose8()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleSubmit9 = () => {
        const apiQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "Climatiq API9")
        );

        onSnapshot(apiQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag9(true)
            }
        })

        if (flag9) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "Climatiq API9"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose9()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleClose10 = () => {
        setOpen10(false)
    }

    const handleClose11 = () => {
        setOpen11(false)
    }

    const handleClose12 = () => {
        setOpen12(false)
    }

    const handleClose13 = () => {
        setOpen13(false)
    }

    function formatDate() {
        var d = new Date(),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
    
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
    
        return [year, month, day].join('-');
    }

    const handleDatabase1 = () => {
        const dbQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "BIM")
        );

        onSnapshot(dbQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag10(true)
            }
        })

        if (flag10) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "BIM"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose10()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection to our database!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        }
    }

    const handleDatabase2 = () => {
        const dbQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "UtilityEnergy")
        );

        onSnapshot(dbQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag11(true)
            }
        })

        if (flag11) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "UtilityEnergy"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose11()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection to our database!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        } 
    }

    const handleDatabase3 = () => {
        const dbQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "TransitionRisk")
        );

        onSnapshot(dbQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag12(true)
            }
        })

        if (flag12) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "TransitionRisk"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose12()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection to our database!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        } 
    }

    const handleDatabase4 = () => {
        const dbQuery = query(
            collection(firestore, 'userDatabase'),
            where('user_email', '==', user_email),
            where('databaseName', '==', "CarbonMarkets")
        );

        onSnapshot(dbQuery, snapshot => {
            if (snapshot.docs.length > 0 ) {
                setFlag13(true)
            }
        })

        if (flag13) {
            alert("You have the same request in the record! Cannot be duplicated!")
        } else {
            const CollectionRef = collection(firestore, 'userDatabase')
            const status = "Not connected"
            const apiAddress = ""
            const databaseName = "CarbonMarkets"
            addDoc(CollectionRef, {user_email, databaseName, status, apiAddress})
            .then(response => {
                console.log(response.id)
                alert("Have sent request! Please wait for us to build connection to your data.")
                handleClose13()

                emailjs.send("teamService","template_cqyfsfh",{
                    subject: "User requested a new API Connection to our database!",
                    name: "API is " + databaseName,
                    email: "from " + user_email,
                    message: "Please check in the firestore \'userDatabase\' collection",
                }, "r87tnpnYE2FXwhAzx");

                const email = user_email
                const content = "Requested an API connection: " + databaseName
                const date = formatDate()
                const time = new Date()
                addDoc(collection(firestore, 'alerts'), {email, content, date, time})
            })
            .catch(error => {
                console.log(error.message)
                alert(error.message)
            })
        } 
    }

    const [payWall, setPayWall] = useState(false)
    useEffect(() => {
        const authQuery = query(
        collection(firestore, 'users'),
        where('username', '==', user_email),
        );
        onSnapshot(authQuery, snapshot => {
            const t = (snapshot.docs.map(doc => ({ data: doc.data().isUpgrade })))
            if (!t[0].data) {
                setPayWall(true)
            }
        })
    }, [])

    return (
        <Box sx={{ display: 'flex', height: '100%' }}>
            {/* Sub-Sidebar layout */}
            <Drawer variant="permanent" open={open} >
                <Toolbar
                    sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    px: [1],
                    height: 66,
                    }}
                >
                    <IconButton onClick={toggleDrawer} sx={{ mr: 1 }}>
                    {open ?<KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
                    </IconButton>
                </Toolbar>
                
                <Divider />

                <List component="nav">
                    <ListItemButton href="/Dashboard/Engineering" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Feeds" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Engineering/Processing" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Processing" />
                    </ListItemButton>

                    <ListItemButton href="/Dashboard/Engineering/Augmentation" >
                            <ListItemIcon>
                                <AssignmentIcon />
                            </ListItemIcon>
                            <ListItemText primary="Data Augmentation" />
                    </ListItemButton>
                </List>
            </Drawer>

            {/* Main space of page*/}
            {payWall? (
            <Box sx={{ height: '100%', width: '100%' }}  display="flex" justifyContent="center" alignItems="center">
                This service is limited to PRO version. Please upgrade your version by clicking the "UPGRADE" button on the top right.
            </Box>
            ) : (
            <Box>
                {/* Title */}
                <Box sx={{ width: '100%' }}>
                    <Typography
                        component="h1"
                        variant="subtitle1"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, mt: 3, ml: 8 }}
                        >
                        Ambient / Data Engineering / Data Augmentation
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h4"
                        color="inherit"
                        noWrap
                        sx={{ flexGrow: 1, ml: 8, mb: 2 }}
                        >
                        Data Augmentation
                    </Typography>
                </Box>

                <Box sx={{ ml: 8, mt: 3 }}>
                    <Typography>Please select one live API below that you'd like to import</Typography>
                    <Box sx={{ ml: 2, mt: 2 }}>
                        <ButtonBase onClick={() => setShow1(show1 => !show1)}><Typography variant="h6" color="#ffb74d">· Climatiq</Typography></ButtonBase>
                        {show1 && 
                            <Box sx={{ ml: 3 }}>
                                <List>
                                    <ListItemButton onClick={() => setOpen1(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /estimate " />
                                            <ListItemText primary="Calculate total estimated emissions" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen2(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /travel/flights" />
                                            <ListItemText primary="Calculate total estimated emissions produced by passenger flights between the specified airports" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen3(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /freight/flights " />
                                            <ListItemText primary="Calculate total estimated emissions produced by freight flights between the specified airports" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen4(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<GET> /compute " />
                                            <ListItemText primary="Returns metadata, such as what sort of providers and regions are available" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen5(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /compute/{provider}/cpu " />
                                            <ListItemText primary="Calculate total estimated emissions based on the usage for a set number of virtual CPU's (vCPUs)" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen6(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /compute/{provider}/storage " />
                                            <ListItemText primary="Calculate total estimated emissions based on storing data for a set amount of time" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen7(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /compute/{provider}/memory " />
                                            <ListItemText primary="Calculate total estimated emissions based on having memory (RAM) available" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen8(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<POST> /classifications/estimate " />
                                            <ListItemText primary="Calculate total estimated emissions produced for a particular activity" />
                                    </ListItemButton>

                                    <ListItemButton onClick={() => setOpen9(true)}>
                                            <ListItemIcon>
                                                <ApiIcon />
                                            </ListItemIcon>
                                            <ListItemText primary="<GET> /search " />
                                            <ListItemText primary="Determine what emission factors are available to be used in your estimates" />
                                    </ListItemButton>
                                </List>

                                <Dialog open={open1} onClose={handleClose1}>
                                    <DialogTitle>API1 Overview</DialogTitle>
                                    <DialogContent>
                                        <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body1" label="Parameters" fullWidth sx={{mb: 3}} defaultValue={JSON.stringify({
                                                    "emission_factor": {
                                                        "activity_id": "heat-and-steam-type_purchased"
                                                    },
                                                    "parameters": {
                                                        "energy": 100,
                                                        "energy_unit": "kWh"
                                                    }
                                                },null,2)} InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result1" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 22.65598068072703,
                                                        "co2e_unit": "kg",
                                                        "co2e_calculation_method": "ar5",
                                                        "co2e_calculation_origin": "climatiq",
                                                        "emission_factor": {
                                                            "activity_id": "heat-and-steam-type_purchased",
                                                            "uuid": "da80d5f9-7fb2-4cd7-aa45-781479499845",
                                                            "id": "heat-and-steam-type_purchased",
                                                            "access_type": "public",
                                                            "source": "EPA",
                                                            "year": "2022",
                                                            "region": "US",
                                                            "category": "Heat and Steam",
                                                            "lca_activity": "unknown",
                                                            "data_quality_flags": []
                                                        },
                                                        "constituent_gases": {
                                                            "co2e_total": null,
                                                            "co2e_other": null,
                                                            "co2": 22.632735465837687,
                                                            "ch4": 0.0004265177043916344,
                                                            "n2o": 0.000042651770439163444
                                                        }
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose1}>Cancel</Button>
                                        <Button onClick={handleSubmit1}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open2} onClose={handleClose2}>
                                    <DialogTitle>API2 Overview</DialogTitle>
                                    <DialogContent>
                                        <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body2" label="Parameters" fullWidth sx={{mb: 3}} defaultValue={JSON.stringify({
                                                "legs": [
                                                    {
                                                        "from": "BER",
                                                        "to": "HAM",
                                                        "passengers": 2,
                                                        "class": "first"
                                                    }
                                                ]
                                                },null,2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result2" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                            "co2e": 1366.7700816154954,
                                                            "co2e_unit": "kg",
                                                            "legs": [
                                                                {
                                                                    "co2e": 116.866091874,
                                                                    "co2e_unit": "kg",
                                                                    "co2e_calculation_method": "ar4",
                                                                    "co2e_calculation_origin": "source",
                                                                    "emission_factor": {
                                                                        "activity_id": "passenger_flight-route_type_domestic-aircraft_type_na-distance_na-class_na-rf_na",
                                                                        "uuid": "c165f89c-7ab9-4473-bfed-ff5ef99bab6f",
                                                                        "id": "passenger_flight-route_type_domestic-aircraft_type_na-distance_na-class_na-rf_na",
                                                                        "access_type": "public",
                                                                        "source": "UBA",
                                                                        "year": "2020",
                                                                        "region": "DE",
                                                                        "category": "Air Travel",
                                                                        "lca_activity": "upstream-fuel_combustion",
                                                                        "data_quality_flags": []
                                                                    },
                                                                    "constituent_gases": {
                                                                        "co2e_total": 116.866091874,
                                                                        "co2e_other": null,
                                                                        "co2": null,
                                                                        "ch4": null,
                                                                        "n2o": null
                                                                    }
                                                                },]
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose2}>Cancel</Button>
                                        <Button onClick={handleSubmit2}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open3} onClose={handleClose3}>
                                    <DialogTitle>API3 Overview</DialogTitle>
                                    <DialogContent>
                                        <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body3" label="Parameters" fullWidth sx={{mb:3}} defaultValue={JSON.stringify({
                                                "legs": [
                                                    {
                                                        "from": "BER",
                                                        "to": "HAM",
                                                        "weight": 0.5,
                                                        "weight_unit": "t"
                                                    }
                                                ]
                                                },null,2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result3" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 2624.110880592884,
                                                        "co2e_unit": "kg",
                                                        "legs": [
                                                            {
                                                                "co2e": 163.228461655,
                                                                "co2e_unit": "kg",
                                                                "co2e_calculation_method": "ar4",
                                                                "co2e_calculation_origin": "source",
                                                                "emission_factor": {
                                                                    "activity_id": "freight_flight-route_type_domestic-distance_na-weight_na-rf_na",
                                                                    "uuid": "f6a15edc-7cef-4f8e-8a6c-d9649e151851",
                                                                    "id": "freight_flight-route_type_domestic-distance_na-weight_na-rf_na",
                                                                    "access_type": "public",
                                                                    "source": "UBA",
                                                                    "year": "2020",
                                                                    "region": "DE",
                                                                    "category": "Air Freight",
                                                                    "lca_activity": "upstream-fuel_combustion",
                                                                    "data_quality_flags": []
                                                                },
                                                                "constituent_gases": {
                                                                    "co2e_total": 163.228461655,
                                                                    "co2e_other": null,
                                                                    "co2": null,
                                                                    "ch4": null,
                                                                    "n2o": null
                                                                }
                                                            },]
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose3}>Cancel</Button>
                                        <Button onClick={handleSubmit3}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open4} onClose={handleClose4}>
                                    <DialogTitle>API4 Overview</DialogTitle>
                                    <DialogContent>
                                        <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={18} id="result4" label="Sample Result" fullWidth defaultValue={JSON.stringify({
                                                            "cloud_providers": {
                                                                "aws": {
                                                                    "provider_full_name": "Amazon Web Services",
                                                                    "provider_id": "aws",
                                                                    "cpu_regions": [
                                                                        "af_south_1",
                                                                        "ap_east_1",
                                                                        "ap_northeast_1"
                                                                        // ...
                                                                    ],
                                                                    "storage_regions": [
                                                                        "af_south_1",
                                                                        "ap_east_1"
                                                                        // ...
                                                                    ],
                                                                    "memory_regions": [
                                                                        "af_south_1"
                                                                        // ...
                                                                    ]
                                                                },
                                                                "azure": {
                                                                    "provider_full_name": "Microsoft Azure",
                                                                    "provider_id": "azure",
                                                                    "cpu_regions": [
                                                                        "central_india",
                                                                        "central_us"
                                                                        // ...
                                                                    ]
                                                                }
                                                                // More providers here
                                                            }
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose4}>Cancel</Button>
                                        <Button onClick={handleSubmit4}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open5} onClose={handleClose5}>
                                    <DialogTitle>API5 Overview</DialogTitle>
                                    <DialogContent>
                                    <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body5" label="Parameters" fullWidth sx={{mb:3}} defaultValue={JSON.stringify({
                                                    "cpu_count": 1,
                                                    "region": "uk_west",
                                                    "cpu_load": 1,
                                                    "duration": 1,
                                                    "duration_unit": "h"
                                                },null,2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result5" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 0.00057841,
                                                        "co2e_unit": "kg",
                                                        "co2e_calculation_method": "ar4",
                                                        "co2e_calculation_origin": "source",
                                                        "emission_factor": {
                                                            "activity_id": "cpu-provider_azure-region_uk_west",
                                                            "uuid": "be353893-f270-43a3-9d0f-82b2a6c8b46c",
                                                            "id": "cpu-provider_azure-region_uk_west",
                                                            "access_type": "public",
                                                            "source": "CCF",
                                                            "year": "2021",
                                                            "region": "GB-CDF",
                                                            "category": "Cloud Computing - CPU",
                                                            "lca_activity": "use_phase",
                                                            "data_quality_flags": []
                                                        },
                                                        "constituent_gases": {
                                                            "co2e_total": 0.00057841,
                                                            "co2e_other": null,
                                                            "co2": null,
                                                            "ch4": null,
                                                            "n2o": null
                                                        }
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose5}>Cancel</Button>
                                        <Button onClick={handleSubmit5}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open6} onClose={handleClose6}>
                                    <DialogTitle>API6 Overview</DialogTitle>
                                    <DialogContent>
                                    <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body6" label="Parameters" fullWidth sx={{mb:3}} defaultValue={JSON.stringify({
                                                    "region": "af_south_1",
                                                    "storage_type": "ssd",
                                                    "data": 50,
                                                    "data_unit": "GB",
                                                    "duration": 1,
                                                    "duration_unit": "day"
                                                },null,2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result6" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 0.0015167280000000004,
                                                        "co2e_unit": "kg",
                                                        "co2e_calculation_method": "ar4",
                                                        "co2e_calculation_origin": "source",
                                                        "emission_factor": {
                                                            "activity_id": "storage-provider_aws-region_af_south_1-type_ssd",
                                                            "uuid": "cb0636c2-d44b-4459-857a-3fc41b469e82",
                                                            "id": "storage-provider_aws-region_af_south_1-type_ssd",
                                                            "access_type": "public",
                                                            "source": "CCF",
                                                            "year": "2021",
                                                            "region": "ZA-CPT",
                                                            "category": "Cloud Computing - Storage",
                                                            "lca_activity": "use_phase",
                                                            "data_quality_flags": []
                                                        },
                                                        "constituent_gases": {
                                                            "co2e_total": 0.0015167280000000004,
                                                            "co2e_other": null,
                                                            "co2": null,
                                                            "ch4": null,
                                                            "n2o": null
                                                        }
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose6}>Cancel</Button>
                                        <Button onClick={handleSubmit6}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open7} onClose={handleClose7}>
                                    <DialogTitle>API7 Overview</DialogTitle>
                                    <DialogContent>
                                    <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body7" label="Parameters" fullWidth sx={{mb:3}} defaultValue={JSON.stringify({
                                                    "region": "us_west_2",
                                                    "data": 8,
                                                    "data_unit": "GB",
                                                    "duration": 24,
                                                    "duration_unit": "h"
                                                },null,2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result7" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 0.02053248,
                                                        "co2e_unit": "kg",
                                                        "co2e_calculation_method": "ar4",
                                                        "co2e_calculation_origin": "source",
                                                        "emission_factor": {
                                                            "activity_id": "memory-provider_gcp-region_us_west_2",
                                                            "uuid": "67193fb7-59ce-4fb3-8245-f559221900a4",
                                                            "id": "memory-provider_gcp-region_us_west_2",
                                                            "access_type": "public",
                                                            "source": "CCF",
                                                            "year": "2021",
                                                            "region": "US-LAX",
                                                            "category": "Cloud Computing - Memory",
                                                            "lca_activity": "use_phase",
                                                            "data_quality_flags": []
                                                        },
                                                        "constituent_gases": {
                                                            "co2e_total": 0.02053248,
                                                            "co2e_other": null,
                                                            "co2": null,
                                                            "ch4": null,
                                                            "n2o": null
                                                        }
                                                    },null,2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose7}>Cancel</Button>
                                        <Button onClick={handleSubmit7}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open8} onClose={handleClose8}>
                                    <DialogTitle>API8 Overview</DialogTitle>
                                    <DialogContent>
                                    <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                            <TextField autoFocus multiline rows={6} id="body8" label="Parameters" fullWidth sx={{mb:3}} defaultValue={JSON.stringify({
                                                    "classification": {
                                                        "classification_type": "isic4",
                                                        "classification_code": "25",
                                                        "source": "EXIOBASE"
                                                    },
                                                    "parameters": {
                                                        "money": 25.0,
                                                        "money_unit": "usd"
                                                    }
                                                }, null, 2)} 
                                                InputProps={{readOnly: true}}/>
                                            <TextField autoFocus multiline rows={12} id="result8" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                        "co2e": 46.61037,
                                                        "co2e_unit": "kg",
                                                        "co2e_calculation_method": "ar5",
                                                        "co2e_calculation_origin": "source",
                                                        "emission_factor": {
                                                            "activity_id": "metal_products-type_fabricated_metal_products_except_machinery_equipment",
                                                            "uuid": "79e87731-dc29-470b-a2fa-73e30797bc53",
                                                            "id": "metal_products-type_fabricated_metal_products_except_machinery_equipment",
                                                            "access_type": "public",
                                                            "source": "EXIOBASE",
                                                            "year": "2021",
                                                            "region": "IN",
                                                            "category": "Fabricated Metal Products",
                                                            "lca_activity": "unknown",
                                                            "data_quality_flags": []
                                                        },
                                                        "constituent_gases": {
                                                            "co2e_total": 46.61037,
                                                            "co2e_other": null,
                                                            "co2": null,
                                                            "ch4": null,
                                                            "n2o": null
                                                        }
                                                    },null, 2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose8}>Cancel</Button>
                                        <Button onClick={handleSubmit8}>Add</Button>
                                    </DialogActions>
                                </Dialog>

                                <Dialog open={open9} onClose={handleClose9}>
                                    <DialogTitle>API9 Overview</DialogTitle>
                                    <DialogContent>
                                        <FormControl sx={{ mt: 2, mb: 2, minWidth: 500 }}>
                                        <TextField autoFocus multiline rows={18} id="result9" label="Sample Result" fullWidth  defaultValue={JSON.stringify({
                                                            "current_page": 1,
                                                            "last_page": 4,
                                                            "total_results": 79,
                                                            "results": [
                                                                {
                                                                    "id": "commercial_vehicle-vehicle_type_truck_light-fuel_source_na-engine_size_na-vehicle_age_na-vehicle_weight_na",
                                                                    "uuid": "05d034db-dfe7-462e-9a19-a69ecd65a114",
                                                                    "name": "Light-Duty Truck",
                                                                    "category": "Vehicles",
                                                                    "sector": "Transport",
                                                                    "source": "EPA",
                                                                    "source_link": "https://www.epa.gov/climateleadership/ghg-emission-factors-hub",
                                                                    "uncertainty": null,
                                                                    "year": "2021",
                                                                    "region": "US",
                                                                    "region_name": "United States",
                                                                    "description": "Emission intensity of light duty truck (includes full-size pickup trucks/full-size vans/extended-length SUVs with wheelbase greater than 121 inches). Retrieved from the EPAs GHG Emission Factors Hub (xlsx).",
                                                                    "unit_type": [
                                                                        "Distance"
                                                                    ],
                                                                    "unit": "kg/mile",
                                                                    "lca_activity": "use_phase",
                                                                    "data_quality_flags": [],
                                                                    "supported_calculation_methods": [
                                                                        "ar4",
                                                                        "ar5"
                                                                    ],
                                                                    "factor": 0.466986,
                                                                    "factor_calculation_method": "ar5",
                                                                    "factor_calculation_origin": "climatiq",
                                                                    "constituent_gases": {
                                                                        "co2e_total": null,
                                                                        "co2e_other": null,
                                                                        "co2": 0.464,
                                                                        "ch4": 0.000012,
                                                                        "n2o": 0.00001
                                                                    }
                                                                },
                                                            ],
                                                            "possible_filters": {
                                                                "year": [
                                                                    "2021"
                                                                ],
                                                                "source": [
                                                                    "ADEME",
                                                                    "BEIS",
                                                                    "EPA",
                                                                    "GHG Protocol"
                                                                ],
                                                                "region": [
                                                                    {
                                                                        "id": "EU",
                                                                        "name": "European Union"
                                                                    },
                                                                    {
                                                                        "id": "FR",
                                                                        "name": "France"
                                                                    },
                                                                    {
                                                                        "id": "GB",
                                                                        "name": "United Kingdom"
                                                                    },
                                                                    {
                                                                        "id": "GLOBAL",
                                                                        "name": "Global"
                                                                    },
                                                                    {
                                                                        "id": "US",
                                                                        "name": "United States"
                                                                    }
                                                                ],
                                                                "category": [
                                                                    "Air Freight",
                                                                    "Air Travel",
                                                                    "Fuel",
                                                                    "Rail Travel",
                                                                    "Road Freight",
                                                                    "Vehicles"
                                                                ],
                                                                "sector": [
                                                                    "Energy",
                                                                    "Transport"
                                                                ],
                                                                "unit_type": [
                                                                    "Distance",
                                                                    "PassengerOverDistance",
                                                                    "Volume",
                                                                    "WeightOverDistance"
                                                                ]
                                                            }
                                                    }, null, 2)} InputProps={{readOnly: true}}/>
                                        </FormControl>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button onClick={handleClose9}>Cancel</Button>
                                        <Button onClick={handleSubmit9}>Add</Button>
                                    </DialogActions>
                                </Dialog>
                            </Box>
                        }

                        <Typography variant="h6" color="#ffb74d"><ButtonBase onClick={() => setOpen10(true)}>· BIM (Ambient)</ButtonBase></Typography>
                        <Typography variant="h6" color="#ffb74d"><ButtonBase onClick={() => setOpen11(true)}>· Utility Energy (Ambient)</ButtonBase></Typography>
                        <Typography variant="h6" color="#ffb74d"><ButtonBase onClick={() => setOpen12(true)}>· Transition Risk (Ambient)</ButtonBase></Typography>
                        <Typography variant="h6" color="#ffb74d"><ButtonBase onClick={() => setOpen13(true)}>· Carbon Markets (Ambient)</ButtonBase></Typography>

                        <Dialog open={open10} onClose={handleClose10} fullWidth={true} maxWidth={"md"}>
                            <DialogTitle>Database Overview</DialogTitle>
                            <DialogContent>
                                <FormControl sx={{ mt: 2, mb: 2, ml: 3, minWidth: 800 }}>
                                    <TextField autoFocus id="type1" label="Data Type" fullWidth sx={{mb: 3}} defaultValue={"Emission intensity of common construction materials"} InputProps={{readOnly: true}}/>
                                    <TextField autoFocus multiline rows={15} id="file1" label="Content" fullWidth defaultValue={
                                        "Material Unit energy(GJ/unit) water(kL/unit) GHG(t CO2-e/unit)\
                                        \nAluminium\
                                        \nvirgin t 253 1084 15.2\
                                        \nreflective foil m2 0.14 0.6 0.008\
                                        \nAsphalt m3 3.08 0.185\
                                        \nBitumen m3 48.4 11.9 2.9\
                                        \nCarpet\
                                        \nwool m2 0.74 2.2 0.044\
                                        \nnylon m2 0.68 1.6 0.041\
                                        \nCeramics\
                                        \nclay bricks (110 mm) m2 0.56 0.7 0.034\
                                        \nceramic tiles m2 0.29 1.1 0.018\
                                        \nterracotta roof tiles (20 mm) m2 0.99 1.5 0.059\
                                    "} InputProps={{readOnly: true}}/>
                                </FormControl>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose10}>Cancel</Button>
                                <Button onClick={handleDatabase1}>Request</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={open11} onClose={handleClose11} fullWidth={true} maxWidth={"sm"}>
                            <DialogTitle>Database Overview</DialogTitle>
                            <DialogContent>
                                <FormControl sx={{ mt: 2, mb: 2, ml: 3, minWidth: 500 }}>
                                    <TextField autoFocus id="type2" label="Data Type" fullWidth sx={{mb: 3}} defaultValue={"Emission intensity of Singapore electricity grid"} InputProps={{readOnly: true}}/>
                                    <TextField autoFocus multiline rows={15} id="file2" label="Content" fullWidth defaultValue={
                                        "Year Carbon intensity in gCO2/kWh\
                                        \n2012 542.08\
                                        \n2013 511.73\
                                        \n2014 497.53\
                                        \n2015 495.68\
                                        \n2016 492.81\
                                        \n2017 494.02\
                                        \n2018 492.21\
                                        \n2019 490.74\
                                        \n2020 488.69\
                                        \n2021 488.21\
                                    "} InputProps={{readOnly: true}}/>
                                </FormControl>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose11}>Cancel</Button>
                                <Button onClick={handleDatabase2}>Request</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={open12} onClose={handleClose12} fullWidth={true} maxWidth={"sm"}>
                            <DialogTitle>Database Overview</DialogTitle>
                            <DialogContent>
                                <FormControl sx={{ mt: 2, mb: 2, ml: 3, minWidth: 500 }}>
                                    <TextField autoFocus id="type3" label="Data Type" fullWidth sx={{mb: 3}} defaultValue={""} InputProps={{readOnly: true}}/>
                                    <TextField autoFocus multiline rows={15} id="file3" label="Content" fullWidth defaultValue={
                                        ""} InputProps={{readOnly: true}}/>
                                </FormControl>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose12}>Cancel</Button>
                                <Button onClick={handleDatabase3}>Request</Button>
                            </DialogActions>
                        </Dialog>

                        <Dialog open={open13} onClose={handleClose13} fullWidth={true} maxWidth={"sm"}>
                            <DialogTitle>Database Overview</DialogTitle>
                            <DialogContent>
                                <FormControl sx={{ mt: 2, mb: 2, ml: 3, minWidth: 500 }}>
                                    <TextField autoFocus id="type4" label="Data Type" fullWidth sx={{mb: 3}} defaultValue={""} InputProps={{readOnly: true}}/>
                                    <TextField autoFocus multiline rows={15} id="file4" label="Content" fullWidth defaultValue={
                                        ""} InputProps={{readOnly: true}}/>
                                </FormControl>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleClose13}>Cancel</Button>
                                <Button onClick={handleDatabase4}>Request</Button>
                            </DialogActions>
                        </Dialog>
                    </Box>

                </Box>
            </Box>
            )}
        </Box>
    );
}
